import styled from "@emotion/styled";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const Loading = () => {
  return (
    <>
      <Container>
        <TitleBox>
          <Spin indicator={<StyledLoadingOutlined spin />} />
          <Title>이미지를 분석 중입니다.</Title>
          <SubTitle>잠시만 기다려 주세요</SubTitle>
        </TitleBox>
      </Container>
    </>
  );
};

export default Loading;

const Container = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  padding: "0 2rem",
}));

const TitleBox = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "2rem",
}));

const StyledLoadingOutlined = styled(LoadingOutlined)(({ theme }) => ({
  fontSize: "100px !important",
  color: theme.color.mint,
}));

const Title = styled.div(({ theme }) => ({
  fontSize: "2.4rem",
  fontWeight: theme.fontWeight.medium,
}));

const SubTitle = styled.div(({ theme }) => ({
  fontSize: "1.4rem",
  color: theme.color.gray,
}));
